import { Button, Group, Select, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { DOCUMENT_TYPE_OPTIONS } from '../constants/documentTypes.ts';
import { DocumentTypeSchema } from '../model.ts';
import type { DocumentType } from '../model.ts';

type DocumentReviewFilterBarProps = {
  keyword: string;
  documentType: DocumentType | null;
  onKeywordChange: (keyword: string) => void;
  onDocumentTypeChange: (documentType: DocumentType | null) => void;
  onReset: () => void;
};

const DocumentReviewFilterBar = ({
  keyword,
  documentType,
  onKeywordChange,
  onDocumentTypeChange,
  onReset,
}: DocumentReviewFilterBarProps) => (
  <Group>
    <TextInput
      w={300}
      placeholder="搜尋Email"
      leftSection={<IconSearch size={16} />}
      value={keyword}
      onChange={(event) => onKeywordChange(event.currentTarget.value)}
    />
    <Select
      w={240}
      placeholder="請選擇駕駛資料類型"
      data={DOCUMENT_TYPE_OPTIONS}
      value={documentType}
      onChange={(value) =>
        onDocumentTypeChange(
          DocumentTypeSchema.nullable().catch(null).parse(value),
        )
      }
      clearable
    />
    <Button variant="default" onClick={onReset}>
      重設
    </Button>
  </Group>
);

export { DocumentReviewFilterBar };
